import { render, staticRenderFns } from "./ReportPreviewFrame.vue?vue&type=template&id=66f9b912&"
import script from "./ReportPreviewFrame.vue?vue&type=script&lang=js&"
export * from "./ReportPreviewFrame.vue?vue&type=script&lang=js&"
import style0 from "./ReportPreviewFrame.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports